import { ChangeEventHandler, KeyboardEventHandler, useState } from 'react'
import { TextField, styled, InputAdornment, Grid } from '@mui/material'
import { GridToolbarContainer as BaseGridToolbarContainer } from '@mui/x-data-grid'
import { useTranslation } from 'react-i18next'
import { Search } from '@mui/icons-material'
import { Search as GWSearch } from 'shared/assets'
import { isGlobalworth } from 'config'

const GWSearchIcon = styled(GWSearch)(({ theme }) => ({
  marginRight: theme.spacing(2),
}))

const GridToolbarContainer = styled(BaseGridToolbarContainer)(({ theme }) => ({
  ...(isGlobalworth && {
    padding: theme.spacing(0.5),
  }),
}))

interface DataGridToolbarProps {
  searchQuery: string
  onSearch: (searchQuery: string) => void
  isLoading: boolean
  label?: string
}

const DataGridToolbar = ({
  searchQuery,
  onSearch,
  isLoading,
  label,
}: DataGridToolbarProps) => {
  const { t } = useTranslation()
  const [query, setQuery] = useState(searchQuery)

  const handleChange: ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = e => setQuery(e.target.value)

  const handleSearch: KeyboardEventHandler<HTMLDivElement> = e => {
    if (e.key !== 'Enter') return
    onSearch(query)
  }

  return (
    <GridToolbarContainer>
      <Grid container>
        <Grid item xs={12} sx={{ p: 1 }}>
          <TextField
            size="small"
            variant="outlined"
            value={query}
            label={label || t('searchBar')}
            onChange={handleChange}
            onKeyPress={handleSearch}
            disabled={isLoading}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {isGlobalworth ? (
                    <GWSearchIcon
                      sx={{ cursor: 'pointer' }}
                      onClick={() => onSearch(query)}
                    />
                  ) : (
                    <Search
                      sx={{ cursor: 'pointer' }}
                      onClick={() => onSearch(query)}
                    />
                  )}
                </InputAdornment>
              ),
            }}
            fullWidth
          />
        </Grid>
      </Grid>
    </GridToolbarContainer>
  )
}

export default DataGridToolbar
